// !!! This file will be generated by ./tool/create.js auto

import Charts from "../../scaffold/src/components/Charts"
import CountDown from "../../scaffold/src/components/CountDown"
import DescriptionList from "../../scaffold/src/components/DescriptionList"
import Exception from "../../scaffold/src/components/Exception"
import FooterToolbar from "../../scaffold/src/components/FooterToolbar"
import GlobalFooter from "../../scaffold/src/components/GlobalFooter"
import HeaderSearch from "../../scaffold/src/components/HeaderSearch"
import NoticeIcon from "../../scaffold/src/components/NoticeIcon"
import PageHeader from "../../scaffold/src/components/PageHeader"
import Result from "../../scaffold/src/components/Result"
import TagSelect from "../../scaffold/src/components/TagSelect"
import AvatarList from "../../scaffold/src/components/AvatarList"
import Trend from "../../scaffold/src/components/Trend"
import NumberInfo from "../../scaffold/src/components/NumberInfo"
import Ellipsis from "../../scaffold/src/components/Ellipsis"
import Authorized from "../../scaffold/src/components/Authorized"
import Login from "../../scaffold/src/components/Login"

export default {
  Charts,
  CountDown,
  DescriptionList,
  Exception,
  FooterToolbar,
  GlobalFooter,
  HeaderSearch,
  NoticeIcon,
  PageHeader,
  Result,
  TagSelect,
  AvatarList,
  Trend,
  NumberInfo,
  Ellipsis,
  Authorized,
  Login
}



// WEBPACK FOOTER //
// ./umd.js